import {useLocation, useNavigate} from "react-router-dom-v5-compat";

export const useUnsetResumeThreadId = () => {
    const {search} = useLocation();
    const navigate = useNavigate();

    return () => {
        const queryParams = new URLSearchParams(search);
        queryParams.delete("resumeThreadId");
        navigate({search: queryParams.toString()}, {replace: true});
    };
};
